import { Suspense, lazy } from 'react'
import { EDITOR_MODE, useSpatialStore } from '@/features/spatial-model/store.js'

const Editor2D = lazy(() => import('@/features/editor2d/Editor2D.jsx'))
const Editor3D = lazy(() => import('@/features/editor3d/Editor3D.jsx'))
const ARPreview = lazy(() => import('@/features/editor3d/ARPreview.jsx'))

export default function WorkspaceCenter({ loading }) {
  const mode = useSpatialStore((s) => s.mode)

  if (loading) {
    return (
      <div className="empty-state">
        <div>Loading floor data…</div>
      </div>
    )
  }

  const fallback = (
    <div className="empty-state">
      <div>Loading viewport…</div>
    </div>
  )

  if (mode === EDITOR_MODE.TWO_D) {
    return (
      <Suspense fallback={fallback}>
        <Editor2D />
      </Suspense>
    )
  }
  if (mode === EDITOR_MODE.THREE_D) {
    return (
      <Suspense fallback={fallback}>
        <Editor3D />
      </Suspense>
    )
  }
  if (mode === EDITOR_MODE.AR_PREVIEW) {
    return (
      <Suspense fallback={fallback}>
        <ARPreview />
      </Suspense>
    )
  }
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', height: '100%', minWidth: 0 }}>
      <Suspense fallback={fallback}>
        <div style={{ borderRight: '1px solid var(--border)', position: 'relative', minWidth: 0 }}>
          <Editor2D />
        </div>
      </Suspense>
      <Suspense fallback={fallback}>
        <div style={{ position: 'relative', minWidth: 0 }}>
          <Editor3D />
        </div>
      </Suspense>
    </div>
  )
}
